var _a;
import { __decorate, __metadata, __param } from "tslib";
import { inject, provide } from '@/inversify.config';
import { GuideService } from './guide-service';
const IS_SORTED = '1';
const IS_SHOW_SORT_TIP = '2';
export const AdvanceSortTipServiceSymbol = Symbol.for('AdvanceSortTipService');
let AdvanceSortTipService = class AdvanceSortTipService {
    constructor(guideService) {
        this.guideService = guideService;
        this.params = {
            key: 'ADVANCE_SORT_TIP',
            type: 'workspace',
        };
        this.showTip = false;
        this.value = null;
        this.initPromise = null;
    }
    get tipVisible() {
        return this.value === IS_SORTED;
    }
    init() {
        this.initPromise = this.guideService.getGuideKey(this.params);
        return this.initPromise
            .then((value) => {
            this.value = value;
            if (this.tipVisible) {
                this.showTip = true;
            }
        })
            .catch((error) => {
            console.log(error);
        });
    }
    async sort() {
        await this.initPromise;
        if (!this.value) {
            this.value = IS_SORTED;
            this.showTip = true;
            await this.guideService.updateGuideKey({
                ...this.params,
                value: IS_SORTED,
            });
        }
    }
    close() {
        this.showTip = false;
        this.value = IS_SHOW_SORT_TIP;
        return this.guideService.updateGuideKey({
            ...this.params,
            value: IS_SHOW_SORT_TIP,
        });
    }
};
AdvanceSortTipService = __decorate([
    provide(AdvanceSortTipServiceSymbol),
    __param(0, inject(GuideService)),
    __metadata("design:paramtypes", [typeof (_a = typeof GuideService !== "undefined" && GuideService) === "function" ? _a : Object])
], AdvanceSortTipService);
export { AdvanceSortTipService };
